export default {
    universeFilter: {
        label: 'Trend universe',
        all: 'all'
    },
    stateFilter: {
        label: 'State',
        all: 'all',
        active: 'active',
        inactive: 'inactive'
    },
    searchBar: {
        label: 'Search',
        min: 'Please enter at least 3 letters to use the search function'
    },
    megatrendFilter: {
        label: 'Mega-trend',
        all: 'all'
    },
    note:
    'Note: Only active trends can be found in the Trendfinder and can be linked to elements. ' +
    'If links to inactive trends already exist, they can still be found.',
    current: 'current Trend universe'
}
